import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import * as wjCore from "wijmo/wijmo";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import {
  ExplorerService,
  ModalConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { SpeCodeListComponent } from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";
import { UnitsDto } from "@dashboard/modules/material-management/unit/model/units.dto";
import { catchError, finalize } from "rxjs/operators";
import { of, forkJoin } from "rxjs";

@Component({
  selector: "kl-new-material",
  templateUrl: "./material-form.component.html",
  styleUrls: ["./material-form.component.scss"],
})
export class MaterialFormComponent implements OnInit, BaseForm, OnDestroy {
  @Input() entity: MaterialDto = new MaterialDto();
  @Input() mode: string;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() isReadOnly: boolean;
  title = "";
  generateCodeSpin = false;
  finishInit = false;
  @ViewChild("newMaterialForm", { static: true }) materialForm: any;
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  // popup status
  SpeCodeListComponent = SpeCodeListComponent;

  vatGroup: any[];
  unitsSource = [];
  unitSetSource = [];
  packageTypes = [
    {
      label: this.translateService.instant("MAIN_PACKAGE"),
      value: "MAIN_PACKAGE",
    },
    {
      label: this.translateService.instant("PLUS_USER"),
      value: "PLUS_USER",
    },
    {
      label: this.translateService.instant("ADDITION_PACKAGE"),
      value: "ADDITION_PACKAGE",
    },
  ];

  tunnel: any;
  user_count = 0;
  unitSetsCollection: wjCore.CollectionView;
  defaultMaterialType = "COMMERCIAL_GOODS";
  // accordion handling
  accordions = {
    general_information: true,
    retail_information: false,
    in_detail_information: false,
    unit_sets: false,
    special_codes: false,
  };

  // options
  materialUnitOptions: Array<UnitsDto>;

  // constructor
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private utilService: UtilService,
    private apiService: ApiService,
    private alertService: KlAlertService,
    private klAlertService: KlSweetAlertService,
    private toastService: ToastService,
    private changeDetector: ChangeDetectorRef,
    private klLoadingService: KlLoadingService,
    private explorerService: ExplorerService
  ) {
    this.tunnel = explorerService.transferState$.subscribe((state) => {
      this.formChange(true);
      switch (state.state) {
        case "SPECODE1_CURRENT_ITEM":
          this.entity.special_code = state.payload.code;
          break;
        case "SPECODE2_CURRENT_ITEM":
          this.entity.special_code2 = state.payload.code;
          break;
        case "SPECODE3_CURRENT_ITEM":
          this.entity.special_code3 = state.payload.code;
          break;
        case "SPECODE4_CURRENT_ITEM":
          this.entity.special_code4 = state.payload.code;
          break;
      }
    });
  }

  // init
  ngOnInit() {
    switch (this.mode) {
      case "add":
        this.generateCode();
        this.entity.status = "ACTIVE";
        this.entity.product_group = "J_RETAIL";
        this.entity.package_type = "MAIN_PACKAGE";
        if (this.entity.hasOwnProperty("type") === false) {
          this.entity.type = this.defaultMaterialType;
        }
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant(this.entity.type);
        break;
      case "copy":
        this.generateCode();
        this.materialUnitOptions = [];
        for (const key in this.entity.material_units) {
          if (this.entity.material_units.hasOwnProperty(key)) {
            const element = this.entity.material_units[key];
            this.materialUnitOptions.push(element.unit);
          }
        }
        if (this.entity.material_companies) {
          for (let i = 0; i < this.entity.material_companies.length; i++) {
            delete this.entity.material_companies[i].id;
          }
        }
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant(this.entity.type);
        delete this.entity.id;
        break;
      case "view":
      case "edit":
        this.materialUnitOptions = [];
        // set materialUnitOptions ..
        for (const key in this.entity.material_units) {
          if (this.entity.material_units.hasOwnProperty(key)) {
            const element = this.entity.material_units[key];
            this.materialUnitOptions.push(element.unit);
          }
        }
        this.title = this.translateService.instant(this.entity.type) + " - ";
        break;
    }
    const unitsRequest = this.apiService
      .getAllData("unit")
      .pipe(catchError((error: any) => this.handleError(error)));
    const unitSetsRequest = this.apiService
      .getAllData("unitSet")
      .pipe(catchError((error: any) => this.handleError(error)));
    const vatRateRequest = this.apiService
      .getAllData("vatgroup")
      .pipe(catchError((error: any) => this.handleError(error)));
    forkJoin([unitsRequest, unitSetsRequest, vatRateRequest])
      .pipe(
        finalize(() => {
          if (this.mode === "edit" || this.mode === "view") {
            this.klLoadingService.hide();
          }
        })
      )
      .subscribe(
        ([unitsResponse, unitSetsResponse, varRateResponse]) => {
          this.vatGroup = varRateResponse;
          this.unitsSource = unitsResponse;
          this.unitSetSource = unitSetsResponse;
          if (!this.entity.vat_group) {
            this.entity.vat_group = this.vatGroup[0] ? this.vatGroup[0] : null;
          }
          if (unitSetsResponse.length > 0) {
            if (this.entity.unit_set) {
              this.unitSetSource.map((unitCode) => {
                if (unitCode.id === this.entity.unit_set.id) {
                  this.entity.unit_set = unitCode;
                }
              });
              if (this.entity.material_units) {
                this.unitSetsCollection = new wjCore.CollectionView(
                  this.entity.material_units
                );
              }
            } else {
              this.entity.unit_set = unitSetsResponse[0]
                ? unitSetsResponse[0]
                : null;
            }
          }
          if (this.entity.user_count >= 1) {
            this.user_count = this.entity.user_count;
          }
          if (this.mode === "add") {
            this.updateMaterialUnits(this.entity.unit_set, false);
          } else {
            this.updateBarcodeUnitSet(this.entity.material_units, false);
          }
          this.finishInit = true;
        },
        (errJoin) => this.handleError(errJoin)
      );
  }

  // generate Code
  generateCode() {
    this.generateCodeSpin = true;
    this.apiService
      .generateCode("material")
      .finally(() => {
        this.klLoadingService.hide();
        this.generateCodeSpin = false;
      })
      .subscribe(
        (resCode) => {
          this.entity.code = resCode.value;
          this.formChange(true);
        },
        (errCode) => this.handleError(errCode)
      );
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  changePackageType(event) {
    this.formChange(true);
    if (event.value === "PLUS_USER") {
      this.user_count = 1;
    } else {
      this.user_count = 0;
    }
  }

  productNumberChange(event) {
    this.formChange(true);
  }

  userCountValueChange(event) {
    if (this.finishInit) {
      this.formChange(true);
      this.entity.user_count = event;
    }
  }

  // commit save
  commitSave(action: any) {
    if (this.materialForm.valid) {
      this.klLoadingService.show("saving");
      if (this.user_count >= 1) {
        this.entity.user_count = this.user_count;
      }
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
            case "copy":
              this.apiService.addData("material", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("material", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("material", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
      }
    } else {
      this.handleError("required_fields_must_be_entered");
    }
  }

  handleResponse(response: any): void {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleError(error: any) {
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    return of(null);
  }

  handleNew(response) {
    this.alertShow = false;
    this.formChange(false);
    this.toastService.toastSuccess();
    this.clearForm();
  }

  setModal(
    title: string,
    stateSelector: string,
    template: any,
    haveFilter = false
  ) {
    if (!this.isReadOnly) {
      const modalConfig = <ModalConfig>{
        title: title,
        stateSelector: stateSelector,
        childTemplate: <DynamicComponent>{
          mode: "DIALOG",
          dblSelect: true,
          template: template,
          templateContext: {
            filter: haveFilter ? { type: "MATERIAL_CARD" } : {},
          },
        },
      };
      this.explorerService.openModal(modalConfig);
    }
  }

  updateUnitSet(event) {
    const unit_set = event.value;
    this.updateMaterialUnits(unit_set, true);
  }

  updateMaterialUnits(data, fresh: boolean) {
    if (data) {
      this.entity.unit_set = data || [];
      this.entity.material_units = data.unit_set_units
        ? data.unit_set_units
        : [];
      this.unitSetsCollection = new wjCore.CollectionView(
        this.entity.material_units
      );
      this.entity.base_unit = data.master_unit ? data.master_unit : [];
      this.updateBarcodeUnitSet(this.entity.material_units, fresh);
      if (fresh || this.mode === "add") {
        if (fresh) {
          this.formChange(true);
        }
        this.unitSetsCollection.refresh();
      }
      this.entity.material_units.forEach((materialUnit) => {
        delete materialUnit.id;
      });
      // clear materialUnitOptions..
      this.materialUnitOptions = [];
      // set materialUnitOptions ..
      for (const key in this.entity.material_units) {
        if (this.entity.material_units.hasOwnProperty(key)) {
          const element = this.entity.material_units[key];
          this.materialUnitOptions.push(element.unit);
        }
      }
    }
  }

  updateBarcodeUnitSet(unitSets, fresh: boolean) {
    this.unitsSource = [];
    unitSets.forEach((unit) => {
      this.unitsSource.push(unit.unit);
    });
  }

  clearForm(): void {
    Object.keys(this.entity).forEach((key) => {
      if (key !== "type") {
        delete this.entity[key];
      }
    });
    this.updateMaterialUnits(this.unitSetSource[0], true);
    this.entity.vat_group = this.vatGroup[0];
    this.klLoadingService.hide();
    this.entity.status = "ACTIVE";
    this.entity.product_group = "J_RETAIL";
    this.entity.package_type = "MAIN_PACKAGE";
    this.generateCode();
  }

  unlockEntity(): void {
    this.apiService.unlockData("material", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
    this.tunnel.unsubscribe();
  }
}
